import { render, staticRenderFns } from "./aprendizado.vue?vue&type=template&id=41b301dd&scoped=true"
import script from "./aprendizado.vue?vue&type=script&lang=js"
export * from "./aprendizado.vue?vue&type=script&lang=js"
import style0 from "./aprendizado.vue?vue&type=style&index=0&id=41b301dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b301dd",
  null
  
)

export default component.exports